/* Barra de progreso de despacho gratis.
   Se apoya en jQuery y en Shopify.formatMoney, que el theme ya carga.
   El umbral llega en centavos desde snippets/js-variables.liquid.

   Ajustes y traducciones se leen de `window.PXUTheme`, no de `window.Shopify`:
   Turbo 9.6.0 movio los dos a su propio namespace. `formatMoney` sigue colgando
   de `window.Shopify`, que es de Shopify y no del theme. */
(function ($) {
  'use strict';

  if (!$) return;

  var settings = (window.PXUTheme && window.PXUTheme.theme_settings) || {};
  if (!settings.free_shipping_enabled) return;

  var THRESHOLD = parseInt(settings.free_shipping_threshold, 10) || 0;
  if (THRESHOLD <= 0) return;

  /* 0 segundos significa que el toast no se cierra solo: queda hasta que el
     comprador lo cierre con la x. Un valor invalido o negativo cae a 8. */
  var TOAST_SECONDS = parseInt(settings.free_shipping_toast_duration, 10);
  if (isNaN(TOAST_SECONDS) || TOAST_SECONDS < 0) TOAST_SECONDS = 8;
  var TOAST_MS = TOAST_SECONDS * 1000;
  var debounceTimer = null;
  var toastTimer = null;
  var pendingShowToast = false;

  /* La exclusión de revestimientos es por TAG, y /cart.js no devuelve tags. En vez
     de pedir /products/<handle>.js por cada producto y cachearlo, se pide
     /cart?view=fsb: un template Liquid que hace el cálculo del lado del servidor,
     donde los tags sí están, con el mismo snippet que usa el primer paint. Acá no
     se replica ninguna regla de negocio, solo se consume el número ya resuelto.

     `state` es lo que devuelve ese endpoint: { subtotal, eligibleCount, itemCount }.
     `subtotal` viene en centavos y antes de descuentos, igual que lo que ve el
     carrier service en el checkout. */
  var CART_STATE_URL = '/cart?view=fsb';

  function hasEligibleItems(state) {
    return !!state && state.eligibleCount > 0;
  }

  /* Un cuerpo que parsea pero no es lo nuestro no puede pasar por estado valido:
     sin esta guarda `subtotal` y `eligibleCount` llegan undefined, la barra se
     esconde y el toast no sale nunca, sin un solo error a la vista. Ver el
     comentario de fetchCartState para el caso concreto que lo produjo. */
  function isCartState(state) {
    return !!state &&
      typeof state.subtotal === 'number' &&
      typeof state.eligibleCount === 'number';
  }

  /* Con fetch y no con $.ajax, a proposito.

     `$.ajax({ dataType: 'json' })` manda `Accept: application/json`, y con ese
     header Shopify NO renderiza la plantilla de /cart?view=fsb: devuelve el
     objeto carro de su propia API -el mismo de /cart.js-, que es JSON valido y
     no tiene ni `subtotal` ni `eligibleCount`. Medido en staging el 2026-08-11,
     misma URL en el mismo instante: fetch devolvio {"subtotal":599000,...} y
     $.ajax devolvio el carro entero. El sintoma era el reportado: agregar un
     producto no mostraba ni el toast ni la barra del mini-carro, sin ningun
     error en consola.

     Es la misma trampa que el Worker del carrier service tiene documentada en
     src/config.ts (alla se pide `text/html` por el mismo motivo).

     De paso desaparece el `global: false` que hacia falta con $.ajax: fetch no
     dispara ajaxSuccess, asi que esta peticion ya no puede reentrar por nuestro
     propio listener. */
  function fetchCartState() {
    return fetch(CART_STATE_URL, {
      headers: { Accept: 'text/html' },
      credentials: 'same-origin'
    }).then(function (response) {
      if (!response.ok) throw new Error('cart state HTTP ' + response.status);
      return response.json();
    });
  }

  function formatMoney(cents) {
    if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
      return window.Shopify.formatMoney(cents, $('body').data('money-format'));
    }
    return new Intl.NumberFormat('es-CL', {
      style: 'currency',
      currency: 'CLP',
      maximumFractionDigits: 0
    }).format(cents / 100);
  }

  function messageFor(total) {
    var translation = (window.PXUTheme && window.PXUTheme.translation) || {};
    var remaining = Math.max(THRESHOLD - total, 0);

    if (remaining > 0) {
      /* split/join en vez de replace: replace con un string solo reemplaza la
         primera ocurrencia. Liquid's `replace` (snippets/free-shipping-bar.liquid)
         sí reemplaza todas, así que si el merchant escribe [monto] dos veces el
         comportamiento tiene que ser el mismo en el primer paint y en cada
         actualización posterior. */
      return String(translation.free_shipping_progress || '')
        .split('[monto]').join(formatMoney(remaining));
    }
    return String(translation.free_shipping_reached || '');
  }

  function render($bar, total) {
    var pct = Math.min(Math.round((total / THRESHOLD) * 100), 100);
    var newText = messageFor(total);

    /* Por elemento, no por el conjunto: $set.text() sobre varias barras a la vez
       devuelve la concatenación de todas, que nunca es igual a newText, así que
       la comparación siempre fallaba y el guard anti-reescritura no hacía nada.
       updateCartBar selecciona todas las barras no-toast juntas (la del carro,
       la del mini-carro y sus copias ocultas), así que esto sí importa. */
    $bar.each(function () {
      var $item = $(this);
      var $message = $item.find('[data-fsb-message]');
      if ($message.text() !== newText) {
        $message.text(newText);
      }
      $item.find('[data-fsb-fill]').css('width', pct + '%');
      $item.find('[data-fsb-track]').attr('aria-valuenow', pct);
    });
  }

  function updateCartBar(total, state) {
    var $cartBar = $('[data-fsb]').not('[data-fsb-variant="toast"]');
    if (!$cartBar.length) return;

    /* Dos motivos distintos para ocultar, no dos criterios en pugna: total<=0
       es el carro vacío (ya se comportaba así) y !hasEligibleItems es el carro
       con ítems pero todos con la etiqueta excluida. Cualquiera de los dos oculta. */
    if (total <= 0 || !hasEligibleItems(state)) {
      $cartBar.attr('hidden', 'hidden');
      return;
    }

    $cartBar.removeAttr('hidden');
    render($cartBar, total);
  }

  var topWatchActive = false;
  var topWatchRaf = null;
  var topWatchSettle = null;
  var topWatchLast = '';
  var TOP_SETTLE_TRIES = 4;

  /* Mide hasta donde llega el header visible, sea fijo o no. En desktop el
     header (.header: promo-banner + top-bar + main-nav__wrapper) es
     position:static y solo ocupa la parte de arriba del viewport mientras la
     pagina esta en scrollY 0; no hay ningun elemento fijo hasta que
     Headhesive pega el clon .sticky_nav (scroll > 700px, ver sections.js).
     Filtrar por posicion fija se perdia ese primer tramo y el toast se
     anclaba al fallback de 20px, quedando tapado por el header estatico
     -el defecto reportado-. Lo que importa no es la posicion CSS sino si el
     elemento toca el borde superior del viewport en este instante: eso vale
     igual para un header fijo pegado arriba (rect.top siempre 0) que para el
     header estatico mientras no se scrollea mas alla de su alto. .sticky_nav
     vive con translateY(-100%) cuando no esta pegado, y ahi su borde inferior
     da 0, asi que no suma. #header es el header movil (fijo cuando
     fixed_header esta activo). Se toma el maximo de los candidatos por si
     hay mas de uno presente a la vez. */
  function topOffset() {
    var nodes = document.querySelectorAll('.sticky_nav, #header, .header');
    /* clientHeight primero: un position:fixed se dimensiona contra el ICB, que
       excluye la barra de scroll horizontal, mientras que innerHeight la
       incluye. Con innerHeight de primario el panel a pantalla completa queda
       corto por el alto de la barra y se cuela por el filtro de abajo. */
    var viewport = document.documentElement.clientHeight || window.innerHeight || 0;
    var bottom = 0;

    Array.prototype.forEach.call(nodes, function (el) {
      var cs = window.getComputedStyle(el);
      if (cs.display === 'none' || cs.visibility === 'hidden') return;

      var rect = el.getBoundingClientRect();
      if (rect.height === 0) return;
      /* Toca el borde superior del viewport, con una banda de tolerancia en vez
         de rect.top <= 0 exacto: ese umbral de tolerancia cero falla en la
         direccion insegura apenas algo lo empuja un poco. Una app que inyecta
         una barra al tope del body (51 apps instaladas, no es hipotetico)
         empuja rect.top a positivo y el candidato se descartaba entero, asi
         que el offset volvia al fallback de 10 y el toast quedaba tapado por
         el header sin ninguna señal. Con overscroll elastico (trackpad de
         macOS, iOS) pasa lo mismo por unos frames al arrastrar en el tope. En
         los dos casos, aceptar el candidato mientras no se haya corrido mas
         que su propio alto sigue anclando debajo del header -la respuesta
         correcta- en vez de degradar al fallback. Todavia y no todavia salio
         entera por arriba (rect.bottom > 0): un header ya scrolleado fuera de
         vista no debe anclar el toast a un valor viejo, por eso bottom > 0 y
         no >= 0. */
      if (rect.top >= rect.height || rect.bottom <= 0) return;
      /* Con body.is-active -menu hamburguesa o dropdown de la cabecera abiertos-
         el theme le pone bottom: 0 al header fijo (styles.css.liquid:1175 y
         :1299) y el rect pasa a ocupar la pantalla entera. Un elemento que
         llega al borde inferior del viewport no es un header: es un panel a
         pantalla completa, y anclar debajo de el dejaria el toast fuera de la
         vista. El limite es el viewport mismo, no un numero elegido a dedo.
         Se filtra por alto y no por borde inferior: la igualdad al filo falla
         por fracciones de pixel con el zoom del navegador, que redondea
         viewport a entero mientras el rect sigue siendo fraccionario. Un
         header que ocupa mas de media pantalla no es un header en ningun
         viewport realista -el #header movil mide 130 sobre 780-. */
      if (viewport && rect.height > viewport / 2) return;
      if (rect.bottom > bottom) bottom = rect.bottom;
    });

    return Math.round(bottom) + 10;
  }

  function applyTopOffset() {
    var value = topOffset() + 'px';
    /* Escribir la misma property con el mismo valor en cada frame de scroll no
       cambia nada y ensucia el estilo inline: si no se movio, no se toca. */
    if (value === topWatchLast) return;
    topWatchLast = value;
    document.documentElement.style.setProperty('--fsb-top-offset', value);
  }

  /* La medicion del rAF llega demasiado temprano: .sticky_nav entra con una
     transicion de 300ms y Headhesive le pone la clase con throttle, asi que a
     un frame del evento el header todavia esta a mitad de camino. Con scroll
     continuo eso se corrige solo, porque siguen llegando eventos; con un salto
     instantaneo (link ancla, tecla Inicio/Fin, scrollTo) no llega ninguno mas y
     el valor queda congelado. Por eso se vuelve a medir cuando el movimiento
     paro, re-armando mientras el valor siga cambiando y cortando solo al
     estabilizarse. Un temporizador y no transitionend: este ultimo dispara una
     vez por propiedad y no llega si la transicion se interrumpe o no corre. */
  function settleTopOffset(tries) {
    window.clearTimeout(topWatchSettle);
    topWatchSettle = window.setTimeout(function () {
      topWatchSettle = null;
      var before = topWatchLast;
      applyTopOffset();
      if (topWatchLast !== before && tries > 1) settleTopOffset(tries - 1);
    }, 350);
  }

  function onTopWatch() {
    settleTopOffset(TOP_SETTLE_TRIES);
    if (topWatchRaf) return;
    topWatchRaf = window.requestAnimationFrame(function () {
      topWatchRaf = null;
      applyTopOffset();
    });
  }

  function isTopPosition($toast) {
    return /\bfsb--pos-top-/.test($toast.attr('class') || '');
  }

  /* Los listeners solo viven mientras el toast esta en pantalla y en una
     posicion superior. Con el modulo apagado, o con una posicion inferior,
     no se engancha nada. */
  function startTopWatch() {
    if (topWatchActive) return;
    topWatchActive = true;
    /* La medida sincronica evita el parpadeo: el toast se muestra ya anclado, en
       vez de usar el default del CSS por un frame. Pero el toast puede abrirse
       con el header a mitad de la transicion de 300ms y sin ningun scroll ni
       resize despues, asi que hace falta la misma re-medicion diferida que en
       onTopWatch: si no, el offset queda congelado en el valor intermedio.
       stopTopWatch cancela este timer igual que cualquier otro. */
    applyTopOffset();
    settleTopOffset(TOP_SETTLE_TRIES);
    window.addEventListener('scroll', onTopWatch, { passive: true });
    window.addEventListener('resize', onTopWatch);
  }

  function stopTopWatch() {
    if (!topWatchActive) return;
    topWatchActive = false;
    window.removeEventListener('scroll', onTopWatch);
    window.removeEventListener('resize', onTopWatch);
    if (topWatchRaf) {
      window.cancelAnimationFrame(topWatchRaf);
      topWatchRaf = null;
    }
    /* La re-medicion diferida no puede sobrevivir al cierre: si el toast se
       cierra dentro de esos 350ms, el timer se cancela y nadie vuelve a
       escribir la property. Sin pendiente no hay quien se re-arme. */
    window.clearTimeout(topWatchSettle);
    topWatchSettle = null;
    topWatchLast = '';
  }

  var cartWatchObserver = null;

  /* El panel del mini-carro se abre agregando la clase active_link a
     .cart-container: por mouseover en desktop (sections.js.liquid:2065-2085),
     por click en movil/touch (sections.js.liquid:1980-1995), y tambien lo hace
     app.js.liquid:838-845 despues de un add. Enganchar el cierre del toast a la
     clase en si -via MutationObserver- en vez de a alguno de esos gestos en
     particular, para no perderse ninguno de los tres caminos.

     Por :visible y no por la sola presencia de la clase: verificado en vivo,
     la rama por defecto de app.js.liquid:843 le agrega active_link a un
     .cart-container que en desktop sin scroll esta dentro del header movil
     oculto (mismo caso que miniCartWillAutoOpen mas abajo). Sin el filtro de
     visibilidad, esa clase "fantasma" cerraria un toast que se decidio
     mostrar justamente porque el panel real no se iba a abrir. */
  function isMiniCartOpen() {
    return $('.cart-container.active_link').is(':visible');
  }

  /* Solo vive mientras el toast esta en pantalla, igual que topWatch: no hay
     necesidad de observar el DOM entero cuando no hay nada que cerrar. */
  function startCartWatch($toast) {
    if (cartWatchObserver || !window.MutationObserver) return;
    cartWatchObserver = new MutationObserver(function () {
      if (isMiniCartOpen()) hideToast($toast);
    });
    /* Los tres .cart-container -el original, el clon de Headhesive y el del
       #header movil- existen desde el DOMReady, o sea antes de que pueda
       existir ningun toast: observarlos directamente evita que cada cambio
       de clase del documento entero (lazysizes marcando lazyloading/
       lazyloaded en cada imagen, animaciones, hovers de otros componentes)
       dispare el callback y su seleccion + :visible, que fuerza lectura de
       layout. */
    var containers = document.querySelectorAll('.cart-container');
    Array.prototype.forEach.call(containers, function (el) {
      cartWatchObserver.observe(el, { attributes: true, attributeFilter: ['class'] });
    });
  }

  function stopCartWatch() {
    if (!cartWatchObserver) return;
    cartWatchObserver.disconnect();
    cartWatchObserver = null;
  }

  function hideToast($toast) {
    stopTopWatch();
    stopCartWatch();
    window.clearTimeout(toastTimer);
    $toast.attr('hidden', 'hidden').removeClass('animated fadeIn');
  }

  function showToast(total, state) {
    /* En la pagina de carrito el add recarga entera y la barra Liquid ya cubre el caso. */
    if ($('body').hasClass('cart')) return;

    /* Red de seguridad, no el filtro principal: refresh() ya decide por el
       mismo criterio y hoy nunca llega aca con un carro no elegible. Se deja
       para que showToast siga siendo correcto si algun dia lo llama otro
       camino. Va antes de tocar $toast y de enganchar topWatch/cartWatch. */
    if (!hasEligibleItems(state)) return;

    /* miniCartWillAutoOpen() solo contesta si el panel se va a abrir solo;
       startCartWatch/isMiniCartOpen solo contesta si se acaba de abrir
       -necesita una mutacion posterior para disparar-. Falta la tercera
       pregunta: si ya estaba abierto cuando llegamos aca. Pasa en desktop
       sin scroll cuando el comprador mueve el mouse al icono del carro
       justo despues del click de agregar: el hover le pone active_link
       al .cart-container visible antes de que termine el debounce propio
       (250ms) mas el round-trip a /cart.js, asi que ni miniCartWillAutoOpen
       -no fue un auto-open- ni el observer -la clase se puso antes de que
       startCartWatch se conectara- lo detectan. Mismo criterio de "panel
       abierto y visible" que usa el observer, para no tener dos
       definiciones distintas de lo mismo conviviendo. */
    if (isMiniCartOpen()) return;

    var $toast = $('[data-fsb][data-fsb-variant="toast"]');
    if (!$toast.length) return;

    /* Mostrar antes de escribir: el aria-live del mensaje solo anuncia si la
       region ya esta en el arbol de accesibilidad cuando cambia el texto. */
    $toast.removeAttr('hidden').addClass('animated fadeIn');
    render($toast, total);

    if (isTopPosition($toast)) startTopWatch();
    startCartWatch($toast);

    window.clearTimeout(toastTimer);
    if (TOAST_MS > 0) {
      toastTimer = window.setTimeout(function () {
        hideToast($toast);
      }, TOAST_MS);
    }
  }

  /* Si el theme va a abrir el mini-carro solo despues del add (cart_action
     "ajax"), mostrar ademas el toast es mostrar lo mismo dos veces. Y no
     alcanza con mostrarlo y dejar que startCartWatch lo cierre cuando el
     panel se abra: app.js.liquid encadena su propio GET /cart.js y recien
     500ms despues de esa respuesta le agrega active_link al .cart-container
     (app.js.liquid:826-844), asi que el panel llega bastante despues de que
     el toast ya esta en pantalla (a los ~250ms de nuestro propio debounce) y
     el cierre se veria como un parpadeo, no como una decision. Por eso el
     corte es preventivo, antes de mostrar el toast, no reactivo despues.

     Pero "cart_action es ajax" no alcanza para saber si ALGO visible se va a
     abrir: app.js.liquid elige el .cart-container por prioridad -#header
     visible, si no .sticky_nav--stick, si no .top-bar- y esa tercera rama,
     verificado en vivo, en desktop sin scroll no apunta a ningun elemento
     visible en este theme (.top-bar solo existe dentro del header movil
     #header, que a esos anchos esta en display:none). Repetir esa misma
     prioridad y confirmar que el elemento elegido este realmente visible es
     la unica forma de no suprimir el toast cuando el panel no va a abrirse
     de verdad -el caso que el brief pide no romper-. */
  function miniCartWillAutoOpen() {
    if (settings.cart_action !== 'ajax') return false;

    var $target;
    if ($('#header').is(':visible')) {
      $target = $('#header .cart-container');
    } else if ($('.sticky_nav--stick').length) {
      $target = $('.sticky_nav .cart-container');
    } else {
      $target = $('.top-bar .cart-container');
    }
    return $target.length > 0 && $target.is(':visible');
  }

  function refresh(showToastAfter) {
    fetchCartState().then(function (state) {
      /* No seguir con algo que no es el estado del carro: cualquier otra cosa
         terminaria ocultando la barra por el motivo equivocado. Se avisa fuerte
         porque el modo de falla es mudo. */
      if (!isCartState(state)) {
        window.console && console.warn('[fsb] respuesta inesperada de ' + CART_STATE_URL, state);
        return;
      }

      /* state.subtotal ya viene filtrado por tag y antes de descuentos: es el
         mismo número contra el que el carrier service decide en el checkout. */
      updateCartBar(state.subtotal, state);

      if (!hasEligibleItems(state)) {
        /* El toast se decide una sola vez, al mostrarse; a diferencia de
           updateCartBar no se re-evalua solo. Si el carro paso a ser todo
           excluido con el toast en pantalla, hay que cerrarlo para que no
           se quede diciendo "Tienes despacho gratis" hasta que expire (o
           para siempre con duracion 0). Via hideToast, no attr('hidden')
           directo, para que desenganche los listeners de scroll/resize del
           anclaje. */
        hideToast($('[data-fsb][data-fsb-variant="toast"]'));
      } else if (showToastAfter && state.itemCount > 0 && !miniCartWillAutoOpen()) {
        showToast(state.subtotal, state);
      }
    })['catch'](function (err) {
      /* No se puede manejar: sin estado no hay con que actualizar la barra, y la
         respuesta correcta es dejarla como esta. Pero callado no: una promesa sin
         catch se pierde entera y este modulo se quedaria mudo justo cuando dejo
         de funcionar. ['catch'] y no .catch por los minificadores viejos, que en
         ES3 tratan `catch` como palabra reservada despues del punto. */
      window.console && console.warn('[fsb] no se pudo leer ' + CART_STATE_URL, err);
    });
  }

  /* pendingShowToast es "pegajoso" a proposito. `app.js` encadena su propio
     GET /cart.js despues del add, sin global:false, y esa peticion vuelve a
     entrar por ajaxSuccess con showToastAfter=false. Si el flag se
     sobreescribiera, ese segundo schedule pisaria al del add y el toast no
     apareceria nunca en produccion, donde /cart.js responde en menos de 250ms. */
  function schedule(showToastAfter) {
    pendingShowToast = pendingShowToast || !!showToastAfter;
    window.clearTimeout(debounceTimer);
    debounceTimer = window.setTimeout(function () {
      var show = pendingShowToast;
      pendingShowToast = false;
      refresh(show);
    }, 250);
  }

  /* Se engancha a las peticiones que el theme ya hace, en vez de agregar las propias. */
  $(document).on('ajaxSuccess', function (event, xhr, options) {
    var url = (options && options.url) || '';
    if (url.indexOf('/cart/add') !== -1) {
      schedule(true);
    } else if (url.indexOf('/cart') !== -1) {
      schedule(false);
    }
  });

  $(document).on('click', '[data-fsb-close]', function () {
    hideToast($(this).closest('[data-fsb]'));
  });

  /* Red de seguridad: la app del cupón no usa nuestro canal, pero sí toca el subtotal. */
  $(function () {
    var subtotals = document.querySelectorAll('.js-cart_subtotal');
    if (!subtotals.length || !window.MutationObserver) return;

    var observer = new MutationObserver(function () {
      schedule();
    });
    Array.prototype.forEach.call(subtotals, function (node) {
      observer.observe(node, { childList: true, subtree: true, characterData: true });
    });
  });
})(window.jQuery);
